// Compatibility layer for the existing UI. It intentionally exposes no database credentials.
const TOKEN_KEY = 'bpa_session_token';
export const session = { get: () => localStorage.getItem(TOKEN_KEY), set: (token) => localStorage.setItem(TOKEN_KEY, token), clear: () => localStorage.removeItem(TOKEN_KEY) };
export async function api(path, options = {}) {
  const headers = { 'content-type': 'application/json', ...(options.headers || {}) };
  const token = session.get();
  if (token) headers.authorization = `Bearer ${token}`;
  const response = await fetch(`/api${path}`, { ...options, headers });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || 'Request failed');
  return body;
}
class Query {
  constructor(table) { this.table = table; this.filters = []; this.sort = null; this.operation = 'select'; this.payload = null; this.options = {}; }
  select(_columns = '*', options = {}) { this.options = options; return this; }
  insert(payload) { this.operation = 'insert'; this.payload = payload; return this; }
  update(payload) { this.operation = 'update'; this.payload = payload; return this; }
  upsert(payload) { this.operation = 'upsert'; this.payload = payload; return this; }
  delete() { this.operation = 'delete'; return this; }
  eq(column, value) { this.filters.push({ column, op: 'eq', value }); return this; }
  neq(column, value) { this.filters.push({ column, op: 'neq', value }); return this; }
  order(column, { ascending = true } = {}) { this.sort = { column, ascending }; return this; }
  single() { this.options.single = true; return this; }
  then(resolve, reject) { return api('/data', { method: 'POST', body: JSON.stringify({ table: this.table, operation: this.operation, payload: this.payload, filters: this.filters, sort: this.sort, options: this.options }) }).then(({ data, count }) => ({ data: this.options.head ? null : (this.options.single ? (data[0] || null) : data), count: this.options.count ? count : null, error: this.options.single && !data[0] ? { message: 'Record not found' } : null })).then(resolve, reject); }
}
export default { from: (table) => new Query(table) };
